export default __webpack_public_path__ + "static/Live-Video_AVAST-e900dc979757de75b8bfe4644fe79308.webp";